import { render } from "./ArrowToLeft.vue?vue&type=template&id=20088715"
import script from "./ArrowToLeft.vue?vue&type=script&lang=js"
export * from "./ArrowToLeft.vue?vue&type=script&lang=js"
script.render = render

export default script